import addAriaLiveLabelHelper from '../actions/addAriaLiveLabelHelper';
import type { AriaLiveLevel } from '../store/schema/AccessibilityStore';
import { getAccessibilityStore } from '../store/Store';
import { mutator } from 'satcheljs';

export default mutator(
    addAriaLiveLabelHelper,
    function addAriaLiveLabelHelperMutator(actionMessage: {
        ariaLiveLabel: string;
        ariaLiveLevel: AriaLiveLevel;
    }) {
        const { ariaLiveLabel, ariaLiveLevel } = actionMessage;
        const { ariaLiveLabels } = getAccessibilityStore();

        if (ariaLiveLabel) {
            // Add an entry if a valid string is sent
            // Even if the string is already present in the dictionary, add the string, since some component might be wanting to highlight that string again
            // Or it might be the case that the politeness level for the string has changed
            ariaLiveLabels.set(ariaLiveLabel, ariaLiveLevel);
        }
    }
);
